import { render, staticRenderFns } from "./PermissionsSelector.vue?vue&type=template&id=1bf6b765&scoped=true&"
import script from "./PermissionsSelector.vue?vue&type=script&lang=ts&"
export * from "./PermissionsSelector.vue?vue&type=script&lang=ts&"
import style0 from "./PermissionsSelector.vue?vue&type=style&index=0&id=1bf6b765&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf6b765",
  null
  
)

export default component.exports